import { setViewportUnits, scrollTo } from './utils/utilities';
import Header from './global/header';
import ThemeToggle from './global/theme-toggle';
import LangSwitcher from './global/lang-switcher';
import MobileMenu from './global/mobile-menu';
import ContactModal from './global/contact-modal';

import HeroMetricsFloat from './templates/hero';
import SelectedWorkTilt from './templates/selected-work';
import Experience from './templates/experience';
import Testimonials from './templates/testimonials';
import ProjectScreens from './pages/project';
import Blog from './pages/blog';

document.addEventListener('DOMContentLoaded', function () {
    setViewportUnits();

    Header(document.querySelector('[data-header]'));
    ThemeToggle();
    LangSwitcher();
    MobileMenu();
    ContactModal();
    Blog();

    scrollTo();

    let hash = window.location.hash;

    if (hash) {
        window.location.hash = '';
    }

    const scrollToHash = (target) => {
        const headerOffset = document.querySelector('.site-header').offsetHeight;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        setTimeout(function () {
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }, 500);
    };

    window.addEventListener('load', () => {
        const target = document.getElementById(hash.substring(1));

        if (target) {
            scrollToHash(target);
        }
    });

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            const target = document.getElementById(this.getAttribute('href').substring(1));

            if (target) {
                e.preventDefault();
                e.stopPropagation();
                scrollToHash(target);
            }
        });
    });

    HeroMetricsFloat();
    SelectedWorkTilt();
    Experience();
    Testimonials();
    ProjectScreens();
});
